import { TeamData } from './types';
import { TeamInfo } from './TeamInfo';

/**
 * Copies a wire-format team update onto a TeamInfo, tracking which fields
 * changed so the grid can flash them. Shared by the live socket and replay so
 * both render from identical state.
 */
export function applyTeamData(target: TeamInfo, data: TeamData): void {
  const trackableFields: (keyof TeamData)[] = [
    'kartNumber', 'position', 'driver', 'teamName', 'lastLap', 'bestLap',
    'gap', 'interval', 'onTrackTime', 'pitCount',
  ];

  for (const field of trackableFields) {
    const newValue = String(data[field] ?? '');
    const oldValue = String((target as unknown as Record<string, unknown>)[field] ?? '');
    if (newValue !== oldValue) {
      target.previousValues.set(field, oldValue);
    }
  }

  target.kartNumber = data.kartNumber;
  target.position = data.position;
  target.driver = data.driver;
  target.teamName = data.teamName ?? '';
  target.category = data.category;
  target.sector1 = data.sector1;
  target.sector2 = data.sector2;
  target.sector3 = data.sector3;
  target.lastLap = data.lastLap;
  target.gap = data.gap;
  target.interval = data.interval;
  target.bestLap = data.bestLap;
  target.onTrackTime = data.onTrackTime;
  target.pitCount = data.pitCount;
  target.inBox = data.inBox;
  target.boxTimeRemaining = data.boxTimeRemaining;
  target.pitEntryTime = data.pitEntryTime;
  target.pitDuration = data.pitDuration;
  // Copied: replay frames share this array between frames, so it must never be
  // the one a team mutates.
  target.lastLapTimes = [...(data.lastLapTimes ?? [])];
  target.lapCount = data.lapCount;
  // Copied as-is: lap times now live in the lap-history store, and older
  // recordings that still carry them are seeded from there.
  target.stintAverages = [...(data.stintAverages ?? [])];
  target.driverSessionAverages = data.driverSessionAverages ?? [];
}

export function teamDataToTeamInfo(data: TeamData): TeamInfo {
  const team = new TeamInfo(data.id);
  applyTeamData(team, data);
  return team;
}

